import { useMemo } from 'react';
import { dispatch, store } from 'redux/store';
import { ReferenceTableMapper } from './mapper';
import {
  useGetReferenceTables,
  getGetReferenceTablesQueryKey,
  getReferenceTables,
} from 'api-client';
import { slice } from 'assetClass/infrastructure/referenceTable/redux';
import { queryClient as moduleQueryClient } from 'common/infrastructure/remoteState/persistQueryClient';
import ReferenceTableItemRepository from './referenceTableItem/repository';
import FieldRepository from '../field/repository';
import loggerService, { LoggerLevel } from 'common/infrastructure/log';

const ReferenceTableRepository = {
  useGetReferenceTables(tenantId?: string) {
    const { auth } = store.getState();

    const useQueryResponse = useGetReferenceTables(
      tenantId || '',
      {
        tenantId: tenantId || '',
      },
      {
        query: {
          enabled: !!tenantId && auth.isAuthenticated && !!auth.user,
        },
      }
    );

    const referenceTableEntities = useMemo(() => {
      if (!useQueryResponse?.data || !Array.isArray(useQueryResponse.data)) {
        return [];
      }
      const referenceTableEntities = useQueryResponse.data.map(ReferenceTableMapper.fromDTO);

      if (referenceTableEntities && !!tenantId && auth.isAuthenticated && !!auth.user) {
        referenceTableEntities.forEach((refTable: { id: string }) => {
          ReferenceTableItemRepository.prefetchReferenceTableItems(refTable?.id).catch((error) => {
            loggerService.log(LoggerLevel.ERROR, error);
          });

          FieldRepository.prefetchFields(refTable?.id).catch((error) => {
            loggerService.log(LoggerLevel.ERROR, error);
          });
        });
      }

      return referenceTableEntities;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(useQueryResponse?.data)]);

    return {
      ...useQueryResponse,
      referenceTableEntities,
    };
  },

  saveCurrent(referenceTableId: string) {
    dispatch(slice.actions.saveCurrent(referenceTableId));
  },

  async prefetchReferenceTables(tenantId: string) {
    const queryKey = getGetReferenceTablesQueryKey(tenantId, { tenantId });
    await moduleQueryClient.prefetchQuery({
      queryKey,
      queryFn: () => getReferenceTables(tenantId, { tenantId }),
    });
  },
};

export default ReferenceTableRepository;
